module.exports = __webpack_public_path__ + "assets/4b904d899cc10e78054699bfa880cf74.jpg";